import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router"
import useFetch from '../../core/hooks/useFetch'
import {IPoster} from '../../core/types/services-types/poster-types'
import PosterService from '../../core/services/PosterService'
import { Button, Container, Flex, Heading, Spinner, Text } from '@radix-ui/themes'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {useAppSelector} from '../../core/store'
import { IUser } from "../../core/types/services-types/user-types"
import { DesktopIcon } from '@radix-ui/react-icons'
import {ROUTES} from '../../routes/constants'
import { toast, ToastContainer } from "react-toastify"
import BaseModal from "../../components/controls/modals/BaseModal"
import {Document, Page} from 'react-pdf'
import Pagination from '../../components/common/renders/pagination-render'
export default function Poster() {

    const [poster, setPoster] = useState<IPoster>()
    const {id} = useParams()
    console.log(id)

    const userData = useAppSelector(store => store.user.user)
    const [user, setUser] = useState<IUser>()
    const [fetchPoster, isLoading, error, errors] = useFetch(async () => {
        if(id) {
        const data = await PosterService.Get(id)
        setPoster(data)
        }
    })

    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
  
    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
      setNumPages(numPages);
    }

    const navigation = useNavigate()

    const moderation = () => navigation(ROUTES.CREATE_POST_ROUTE + `?id=${id}`)

    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
    }

    const renderContentPdfModal = (url: string) => {
        return (
       <Container> 
      <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>
       <Pagination total={numPages} count={1} activeIndex={pageNumber} onChangeIndex={setPageNumber} classNameContainer="flex-wrap"/>
      </Container>
        )
    }


    useEffect(() => {
        fetchPoster()
    }, [])

    useEffect(() => {
        setUser(userData)
    }, [userData])


    useEffect(() => {
        if(error.length) toast.error(error)
    }, [error])


    return (
        <Container className="mt-10 max-w-[100%]">
            <ToastContainer />
            {poster ? 
            <Container>

            <Container className="max-w-[600px] w-[100%] h-[auto] mb-10">
                <img src={poster.main_image} />
            </Container>

            <Container>
            <Flex className="bg-zinc-50 p-5 rounded-lg shadow-lg mb-5" justify={'between'} align={'center'}>

                <Heading>
                    {poster.title}
                </Heading>

                {user?.role === 'admin' ? 
                <Button onClick={moderation}>
                    Модерация
                    <DesktopIcon />
                </Button>
                :
                ''
                }

            </Flex>
            <Container className="bg-zinc-50 p-5 rounded-lg shadow-lg mb-5">
                <Heading>
                    Описание
                </Heading>
                <hr />
               <div className="whitespace-pre-line pt-5" dangerouslySetInnerHTML={{__html: poster.text.split(' ').map(item => {
                if(item.includes('http') && !item.includes('<') && !item.includes('>') && !item.includes('="')) {
                item = `<a href=${!item.includes('http') ? `https://${item}` : item}>${item}</a>`
                }
        return item
        }).join(' ')}}/>
         
            </Container>
            {poster.image.length
            ?
            <Container className="bg-zinc-50 p-5 rounded-lg shadow-lg">
                <Carousel 
                responsive={responsive}
                swipeable={false}
                draggable={false}
                showDots={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                customTransition="all 1"
                transitionDuration={1000}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                >
                    {poster.image.filter(asset => asset.type_asset === 'photo').map(image => {

                        return (
                            <Container className="max-w-[100%]">
                                <img src={image.url} />
                            </Container>
                        )
                    })}
                </Carousel>
            </Container>
            :
            ''
            }

<Container className="bg-zinc-50 p-5 rounded-lg shadow-lg mt-5">
                <Heading>
                    Доп материалы
                </Heading>
                <hr />

                {poster.image.filter(file => file.type_asset === 'pdf').map(pdf => {
                    let nameFile = pdf.url.split('/')
                    let nameFileStr = nameFile[nameFile.length - 1]
                    const content = renderContentPdfModal(pdf.url)
                    return (
                        <Flex align={'center'} gap={'2'} className="mt-2">
                        <Text>📑{nameFileStr}</Text>
                        <BaseModal 
                        maxWidth="700px"
                        showButton={<Button>Читать</Button>}
                        title={nameFileStr}
                        description={content}
                        cancelButton={<></>}
                        successButton={<Button>Готово</Button>}
                        />
                        </Flex>
                    )
                })}
            </Container>

            </Container>
            </Container>
            :
            <Flex align={'center'} justify={'center'}>
            <Spinner size={'3'} />
            </Flex>
            }
        </Container>
    )
}